import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "30",
  viewBox: "0 0 36 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M24.1523 3.15C27.2215 3.15 29.772 5.46224 30.2316 8.47483C33.1736 8.94551 35.5 11.5572 35.5 14.7C35.5 18.174 32.6719 21 29.2793 21H26.75V17.5C26.75 12.6675 22.8325 8.75 18 8.75C13.1675 8.75 9.25 12.6675 9.25 17.5V21H6.7207C3.3281 21 0.5 18.174 0.5 14.7C0.5 11.5838 2.78936 8.98856 5.69634 8.48715C5.69531 8.45845 5.69531 8.4287 5.69531 8.4C5.69531 3.76831 9.3753 0 13.8984 0C16.8264 0 19.462 1.56779 20.926 4.08723C21.8883 3.47711 22.9978 3.15 24.1523 3.15ZM16.25 28C16.25 28.9665 17.0335 29.75 18 29.75C18.9665 29.75 19.75 28.9665 19.75 28L19.75 17.3499L21.1376 18.7374C21.821 19.4209 22.929 19.4209 23.6124 18.7374C24.2959 18.054 24.2959 16.946 23.6124 16.2626L19.2374 11.8876C18.554 11.2041 17.446 11.2041 16.7626 11.8876L12.3876 16.2626C11.7041 16.946 11.7041 18.054 12.3876 18.7374C13.071 19.4209 14.179 19.4209 14.8624 18.7374L16.25 17.3499L16.25 28Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}